<template>
  <div class="incidents-page">
    <!-- Header Section -->
    <AppHeader 
      header-text="Drivers in your state can save up to $600/year"
      button-text="FREE CALL"
    />

    <!-- Progress Bar -->
    <div class="progress-container">
      <div class="progress-bar">
        <div class="progress-fill"></div>
      </div>
    </div>

    <!-- Navigation -->
    <div class="navigation">
      <div class="container">
        <button class="back-btn" @click="goBack">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          Previous Question
        </button>
      </div>
    </div>

    <!-- Incidents Section -->
    <section class="incidents-section">
      <div class="container">
        <div class="incidents-content">
          <PageTitle title="Incidents In The Past 3 Years" />
          
          <div class="incidents-form">
            <!-- Had an accident -->
            <div class="incident-row">
              <div class="incident-label">Had an accident</div>
              <div class="incident-options">
                <button 
                  :class="['incident-btn', 'no-btn', { 'selected': accidentSelected === 'No' }]"
                  @click="selectIncident(0, '0')"
                >
                  No
                </button>
                <button 
                  :class="['incident-btn', 'yes-btn', { 'selected': accidentSelected === 'Yes' }]"
                  @click="selectIncident(0, '1')"
                >
                  Yes
                </button>
              </div>
            </div>

            <!-- Received a ticket -->
            <div class="incident-row">
              <div class="incident-label">Received a ticket</div>
              <div class="incident-options">
                <button 
                  :class="['incident-btn', 'no-btn', { 'selected': ticketSelected === 'No' }]"
                  @click="selectIncident(1, '0')"
                >
                  No
                </button>
                <button 
                  :class="['incident-btn', 'yes-btn', { 'selected': ticketSelected === 'Yes' }]"
                  @click="selectIncident(1, '1')"
                >
                  Yes
                </button>
              </div>
            </div>

            <!-- Received a DUI -->
            <div class="incident-row">
              <div class="incident-label">Received a DUI</div>
              <div class="incident-options">
                <button 
                  :class="['incident-btn', 'no-btn', { 'selected': duiSelected === 'No' }]"
                  @click="selectIncident(2, '0')"
                >
                  No
                </button>
                <button 
                  :class="['incident-btn', 'yes-btn', { 'selected': duiSelected === 'Yes' }]"
                  @click="selectIncident(2, '1')"
                >
                  Yes
                </button>
              </div>
            </div>

            <!-- Continue Button -->
            <div class="continue-section">
              <button 
                class="continue-btn"
                @click="continueToNext"
              >
                CONTINUE
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Footer Links -->
    <AppFooter />
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader.vue'
import AppFooter from '@/components/AppFooter.vue'
import PageTitle from '@/components/PageTitle.vue'
import { submitDataAndLog } from '@/utils/localStorage'

export default {
  name: 'IncidentsPage',
  components: {
    AppHeader,
    AppFooter,
    PageTitle
  },
  data() {
    return {
      userQuoteData: null,
      incidents: ['0', '0', '0'] // 默认三个NO，对应[accident, ticket, dui]
    }
  },
  computed: {
    allIncidentsSelected() {
      // 始终返回true，因为有默认值
      return true
    },
    // 用于显示按钮状态的计算属性
    accidentSelected() {
      return this.incidents[0] === '1' ? 'Yes' : 'No'
    },
    ticketSelected() {
      return this.incidents[1] === '1' ? 'Yes' : 'No'
    },
    duiSelected() {
      return this.incidents[2] === '1' ? 'Yes' : 'No'
    }
  },
  mounted() {
    this.loadUserData()
  },
  methods: {
    loadUserData() {
      const storedData = localStorage.getItem('quoteData')
      if (storedData) {
        try {
          this.userQuoteData = JSON.parse(storedData)
          // 检查是否有选择的生日信息
          if (!this.userQuoteData.birthday) {
            // 如果没有完整的生日信息，跳转回birth-year页面
            this.$router.push('/birth-year')
            return
          }
          // 加载之前选择的事故信息（如果有的话）
          if (this.userQuoteData.incidents && Array.isArray(this.userQuoteData.incidents)) {
            this.incidents = [...this.userQuoteData.incidents]
          } else {
            // 如果没有incidents数据，初始化默认值并保存
            this.userQuoteData.incidents = [...this.incidents]
            this.saveUserData()
          }
        } catch (error) {
          console.error('Error parsing stored data:', error)
          this.$router.push('/')
        }
      } else {
        // 如果没有数据，跳转回首页
        this.$router.push('/')
      }
    },
    
    saveUserData() {
      localStorage.setItem('quoteData', JSON.stringify(this.userQuoteData))
    },
    
    selectIncident(index, value) {
      // 确保响应式更新：创建新数组
      const newIncidents = [...this.incidents]
      newIncidents[index] = value
      this.incidents = newIncidents
      
      // 更新用户数据
      this.userQuoteData.incidents = [...this.incidents]
      this.saveUserData()
      
      const incidentTypes = ['accident', 'ticket', 'dui']
      console.log(`Selected ${incidentTypes[index]}:`, value === '1' ? 'Yes' : 'No')
    },
    
    async continueToNext() {
      // 确保incidents数据已保存
      this.userQuoteData.incidents = [...this.incidents]
      this.saveUserData()
      
      // 检查是否所有选项都是"0"（No）
      const allNo = this.incidents.every(incident => incident === '0')
      
      console.log('Incidents navigation:', allNo ? 'All No -> /name' : 'Has Yes -> /ticket-details')
      
      // 提交数据并记录页面提交事件
      await submitDataAndLog('incidents')
      
      if (allNo) {
        // 如果都是"0"（NO），跳转到Name页面
        this.$router.push('/name')
      } else {
        // 如果有任何"1"（Yes），跳转到Ticket Details页面
        this.$router.push('/ticket-details')
      }
    },
    
    goBack() {
      this.$router.push('/birth-year')
    }
  }
}
</script>

<style scoped>
/* Page Layout */
.incidents-page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

/* Navigation */
.navigation {
  padding: 1rem 0;
}

.back-btn {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: none;
  border: none;
  color: #999;
  font-size: 0.9rem;
  cursor: pointer;
  transition: color 0.3s ease;
}

.back-btn:hover {
  color: #666;
}

/* Incidents Section */
.incidents-section {
  padding: 2rem 0 4rem;
  background: #fff;
  flex: 1;
}

.incidents-content {
  text-align: center;
  max-width: 800px;
  margin: 0 auto;
  padding: 0 2rem;
}

.incidents-form {
  margin-top: 2rem;
}

.incident-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1.5rem;
  padding: 1rem 2rem;
  border-radius: 8px;
  background: #f8f9fa;
}

.incident-label {
  font-size: 1.1rem;
  font-weight: 500;
  color: #333;
  text-align: left;
}

.incident-options {
  display: flex;
  gap: 0;
}

.incident-btn {
  padding: 0.8rem 2rem;
  border: 2px solid #007bff;
  background: #f8f9fa;
  color: #007bff;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 80px;
}

.incident-btn.no-btn {
  border-radius: 8px 0 0 8px;
  border-right: 1px solid #007bff;
}

.incident-btn.yes-btn {
  border-radius: 0 8px 8px 0;
  border-left: 1px solid #007bff;
}

.incident-btn:hover {
  background: #e7f3ff;
}

.incident-btn.selected {
  background: #007bff;
  color: #fff;
}

.incident-btn.selected.no-btn {
  background: #007bff;
}

.incident-btn.selected.yes-btn {
  background: #007bff;
}

/* Continue Section */
.continue-section {
  margin-top: 3rem;
  padding-top: 2rem;
}

.continue-btn {
  padding: 1rem 3rem;
  border: 2px solid #007bff;
  border-radius: 8px;
  background: #fff;
  color: #007bff;
  font-size: 1.1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 200px;
}

.continue-btn:hover:not(:disabled) {
  background: #f8f9fa;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0,123,255,0.15);
}

.continue-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Responsive Design */
@media (max-width: 768px) {
  .incidents-content {
    padding: 0 1rem;
  }

  .incident-row {
    flex-direction: column;
    align-items: stretch;
    gap: 1rem;
    padding: 1.5rem;
  }

  .incident-label {
    text-align: center;
    margin-bottom: 0.5rem;
  }

  .incident-options {
    justify-content: center;
  }

  .incident-btn {
    flex: 1;
    max-width: 120px;
  }

  .continue-btn {
    width: 100%;
    max-width: 300px;
  }
}

@media (max-width: 480px) {
  .incidents-content {
    padding: 0 0.5rem;
  }

  .incident-row {
    padding: 1rem;
  }

  .incident-label {
    font-size: 1rem;
  }

  .incident-btn {
    padding: 0.7rem 1.5rem;
    font-size: 0.9rem;
  }

  .continue-btn {
    padding: 0.8rem 2rem;
    font-size: 1rem;
  }
}
</style>
